(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDeleteController',PhoneCallCheckDeleteController);

    PhoneCallCheckDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallCheck'];

    function PhoneCallCheckDeleteController($uibModalInstance, entity, PhoneCallCheck) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallCheck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
